import { bindKeymapWithCommand, escape } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { clearEditingContext } from '../editor-commands/commands';
import { getPluginState } from './plugin-factory';
export default function keymapPlugin(applyChange) {
  var list = {};
  bindKeymapWithCommand(
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  escape.common, function (state, dispatch) {
    var extensionState = getPluginState(state);
    if (!extensionState.showContextPanel) {
      return false;
    }
    return clearEditingContext(applyChange)(state, dispatch);
  }, list);
  return keymap(list);
}